export default {
  title: 'Academy',
  description:
    'Create courses for your users, and link them using academy builder.',
  tab: {
    course: {
      title: 'Course Builder',
      desc:
        'Edit course settings, import your videos as video lessons, and vóila — a new course.',
      cta: 'Create a course'
    },
    builder: {
      title: 'Academy Builder',
      desc: 'Offer courses personalised for your users.',
      cta: 'Go to Academy Builder'
    }
  },
  button: {
    enable: 'Enable Academy',
    disable: 'Disable Academy'
  },
  quiz: {
    untitled: 'Untitled Quiz',
    imported_successfully: 'Quiz Imported Successfully',
    title: 'Edit Questions',
    description:
      'Add multiple choice / checkbox type questions to your assesment.',
    question: {
      title: 'Question Title',
      type: 'Question Type',
      add_option: 'Add Option',
      add: 'Add Question',
      answer_hint: 'Set as Answer'
    }
  },
  analytics: {
    allow_crawling: 'Allow google to crawl your academy',
    allow_crawling_label: 'For Search Engine Optimisation',
    allow_ga_label: 'For Google Analytics',
    allow_ga: 'Enable Google Analytics',
    enter_tracking_code: 'Enter code',
    tracking_code_label: 'Google Analytics tracking code',
    tracking_code_desc: 'Copy and paste your Google Analytics tracking code',
    cross_origin_tracking_label: 'Enable cross origin tracking',
    origin_ids_label: 'Origin Ids',
    origin_ids_placeholder: 'Enter domain names',
    origin_ids_desc: 'Use comma to separate domain names'
  },
  lesson: {
    untitled: 'Untitled Lesson',
    delete: 'Delete Lesson'
  },
  courses: {
    all_corses: 'All Courses',
    create: 'Create Course',
    link_course: 'Link Course',
    course_builder: 'Course Builder',
    untitled: 'Untitled Course',
    desc_placeholder:
      'Write a brief course overview — this will be displayed on the course card making it easier for your learners to grasp course benefits.',
    sort: {
      based_on: 'Sort your courses based on recently',
      created: 'created',
      updated: 'updated',
      published: 'published'
    },
    publish: 'Publish Course',
    published_successfully: 'Course published succesfully',
    sub_heading:
      '<b>Create a Course</b> — will be added to your “All Courses” library',
    analytics: 'Analytics',
    upload: {
      title: 'Course Cover',
      type: 'Upload Image',
      desc: 'upto 1920x1280',
      from_library: 'Choose Video',
      from_library_desc: 'from Library',
      pdf: 'Upload PDF',
      loading: 'Uploading...',
      video: 'Video Updated Successfully'
    },
    tabs: {
      general: 'General',
      content: 'Course Content',
      assesment: 'Assessment',
      certificate: 'Certificate'
    },
    general: {
      details: 'Course Description',
      description: 'Edit this course’s description:',
      comment_title: 'Learners can comment on your video lesssons',
      comment_desc:
        'Comments are public— anyone who can access this course can see these comments.',
      internal_name: 'Internal Name',
      internal_name_desc:
        'This name will not be visible to learners and will be helpful to identify multi-lingual courses.',
      chapters_title: 'Learners can jump between Chapters in your Course',
      chapters_desc:
        'This setting allows your learners can consume the course content non-sequentially.',
      assesment_title:
        'Learners can get certified through an assesment at the end of this course',
      assesment_desc:
        'You will be required to set up a detailed assesment round under the “Assesment” tab',
      include_pricing_title: 'Make this a paid course',
      include_pricing_desc: 'Learners have to pay to take the course',
      strikethrough_price_title: 'Original Price',
      strikethrough_price_desc: 'Original price of the course',
      discount_price_title: 'Discounted Price',
      discount_price_desc:
        'Final price that is to be payable after discount to access the content',
      currency_title: 'Currency',
      currency_desc:
        'Currency in which the course has to be charged to access the content',
      author: {
        label: 'Add Course Authors',
        desc: 'Enable this setting to add authors for this course',
        add: 'Add Author Information',
        modal_title: 'Add Author Details',
        modal_desc:
          'You can choose from the list or add new author information',
        no_author_found: 'No Authors found!'
      }
    },
    chapter: {
      untitled: 'Untitled Chapter',
      add: 'Add Chapter',
      empty:
        'Start by adding a chapter — which helps you to group video lessons on a topic together.',
      reorder: 'Reorder you chapters',
      reorder_desc:
        'Reorder your chapters the way you want them to appear in the end user interface.',
      delete: {
        title: 'Are you sure you want to delete this Chapter?',
        description: 'On deleting, this Chapter will be deleted forever.',
        delete_btn: 'Yes, Delete it!',
        cancel: "No, don't delete it"
      }
    },
    lesson: {
      untitled: 'Untitled Lesson',
      add: 'Add Lesson',
      edit: 'Edit Video Lesson',
      from_library: '',
      description_label: 'Lesson Description',
      description_caption: 'Edit this lesson’s description.',
      supporting_document: 'Supporting Documents',
      maximum_upload_size: 'Maximum Upload Size: %{size}MB',
      article: {
        edit: 'Edit Article Lesson',
        description_label: 'Article Content',
        description_caption: 'Edit this articles’s content.'
      },
      delete: {
        title: 'Are you sure you want to delete this lesson?',
        description:
          'On deleting, this lesson will be deleted forever. All the links associated with this lesson will not be available anymore.',
        delete_btn: 'Yes, Delete it!',
        cancel: "No, don't delete it"
      }
    },
    empty: 'Your Course Library is empty. Start by creating a course.',
    delete: {
      title: 'Are you sure you want to delete this course?',
      description:
        'On deleting, this course will be deleted forever. All the links associated with this course will not be available anymore.',
      delete_btn: 'Yes, Delete it!',
      cancel: "No, don't delete it"
    },
    assessment: {
      upload_question: 'Upload Questions',
      add_update_questions: 'Questions',
      question_description:
        'Add multiple choice / checkbox type questions to your assesment',
      quiz_builder: 'Quiz Builder',
      go_to_quiz_add: 'Add Questions',
      go_to_quiz_edit: 'Edit Questions',
      import_questions: 'Import Questions',
      upload_question_desc: 'Watch video to learn more',
      without_completeing_course_label:
        'Get certified without course completion',
      without_completeing_course_desc:
        'Your learners can take the assessment without watching any videos in the course.',
      minimum_duration_label: 'Estimated time to finish the assessment',
      minimum_duration_desc:
        'This is to inform your learners about the average time it takes to complete the assessment.',
      maximum_duration_label: 'Make the assessment time-bound',
      maximum_duration_desc:
        'Keep the assessment portal open for your learners for a certain duration before it auto-submits.',
      pass_percentage_label: 'Pass percentage',
      pass_percentage_desc:
        'What should your learners score on the assessment to pass and earn this certificate.',
      attempts_label: 'Assessment reattempt on failure',
      attempts_desc:
        'Set the number of times your learners can retake the assessment, on failure to score the pass percentage.',
      attempts_gap_label: 'Reattempt window',
      attempts_gap_desc:
        'Set the duration your learners have to wait between reattempts of the assessment, on failure.',
      none: 'None',
      limitless: 'Limitless',
      custom: 'Custom',
      hours: 'Hours',
      hour: 'Hour',
      mins: 'Mins',
      error: {
        question_title: 'Please fill the question title',
        question_points: 'Please fill the question points',
        option_text: 'Please fill the option text',
        option_correct: 'Please select the correct option',
        duplicate_choices: 'Please enter unique choices'
      }
    },
    certificate: {
      validity_label: 'Certification Validity',
      validity_desc:
        'From the date of issuance, how long is the certificate valid for',
      content_label: 'Certification text',
      content_desc: 'This template will be reflected across all certificates',
      auth_label: 'Authorization Information',
      auth_desc:
        'Enter the details of the signing authority of the certification',
      logo_label: 'Logo on the certificate',
      logo_desc: 'Upload a transparent .png of the company logo',
      content_text1: 'This is to certify that',
      content_text2: 'has successfully completed the course',
      learner_name: 'learner name',
      course_name: 'course name',
      logo_file_desc: '<b>Signature:</b> Upto 2800x1800 | .png',
      authority_name: 'Name of the authority',
      signature_preview: 'Signature Preview',
      course_certificate_name: 'Course Certificate Name',
      course_certificate_name_desc:
        'Override the course name with a different name in the certificate.'
    }
  },
  builder: {
    publish: 'Publish Academy',
    published_successfully: 'Academy published succesfully',
    upload: {
      title: 'Page Cover'
    },
    delete: {
      title: 'Are you sure you want to delete %{page} page?',
      description: 'On deleting, %{page} page will be deleted forever.',
      delete_btn: 'Yes, Delete it!',
      cancel: "No, don't delete it"
    },
    language: {
      delete: {
        title: 'Are you sure you want to delete %{language} Academy Page?',
        description:
          'On deleting, %{language} Academy Page will be deleted forever.',
        button: 'Yes, Delete it!',
        cancel: "No, don't delete it"
      }
    },
    pages: {
      login: 'Login Page',
      home: 'Home Page'
    },
    login: {
      title: 'Login Settings',
      public: {
        caption: 'Your Academy is Public',
        title: 'Everybody can access your academy'
      },
      private: {
        caption: 'Your Academy is Private',
        title: 'Authenticate your users before allowing',
        custom_sso:
          'You have configured a custom SSO implementation. Contact our support team to modify'
      },
      auth_type: {
        sso: 'Use SSO Authentication',
        sso_documentation_link:
          "Read this <a target='_blank' href='https://trainn.notion.site/Trainn-Single-Sign-On-Integration-3fbbb8727fe542fb8d9ee04b8390f6f2'>documentation</a> on how to integrate SSO with video academy.",
        train_login: 'Use Email Authentication',
        train_auth_customer_signup: 'Allow anyone to signup',
        login_url: 'Paste redirection URL',
        login_url_label: 'SSO Authentication'
      }
    },
    design: {
      login_title: 'Login Page Design',
      home_title: 'Home Page Design',
      header: 'Edit page heading',
      sub_header:
        'Edit page sub-heading: Give a hearty welcome to your users or a brief overview of what they can expect from your academy',
      layout_title: 'Choose Layout',
      layout: {
        left: 'Form left on the page',
        center: 'Form centered on the page',
        right: 'Form right on the page'
      },
      home_layout: {
        left: 'Banner Image aligned to the left of the page',
        center: 'Banner Image centered on the page',
        right: 'Banner Image aligned to the right of the page'
      },
      align: {
        left: 'Linear with left aligned headers',
        center: 'Linear with left aligned headers',
        right: 'Linear with left aligned headers'
      },
      brand: 'Add Brand Essentials'
    },
    settings: {
      title: 'Advanced Settings',
      header: {
        caption: 'Header',
        title: 'You can add up to three links in your academy header'
      },
      footer: {
        caption: 'Foot notes',
        title: 'Enable a footer for the page'
      },
      add_login_foot_note:
        'Add a footnote to the login page — add links if you need',
      add_foot_note:
        'Add a footnote to direct your users to your desired page in case they need further support',
      link_text: 'Link Text',
      label: 'Label',
      url: 'URL',
      edit_home_page:
        'Customise the home page of your academy by linking desired courses',
      edit_home_cta: 'Edit Home Page',
      override_home_page: 'Show different courses for custom user segments',
      override_home_cta: 'Create New Home Override',
      override_title:
        'Override: Create a new home override for custom user segments',
      override_title_placeholder: 'Name it for your reference',
      override_title_desc:
        'In the following step, you can set up who has access to this page',
      override_title_cta: 'Create Page',
      add_link: 'Add link',
      edit_link: 'Edit link',
      remove_link: 'Remove link'
    },
    content: {
      link_courses: 'Link Courses'
    },
    categories: {
      untitled: 'Untitled Category',
      add: 'Add Category',
      empty:
        'Start by creating a category — which helps you to group courses together.',
      reorder: 'Reorder your categories',
      delete: {
        title: 'Are you sure you want to delete this Category?',
        description: 'On deleting, this Category will be deleted forever.',
        delete_btn: 'Yes, Delete it!',
        cancel: "No, don't delete it"
      }
    }
  },
  conditions: {
    title: 'Who can see this page?'
  },
  config: {
    title: 'Academy Settings',
    desc: 'Set up analytics, custom domain, and more for your academy',
    cta: 'Save Configurations',
    brand_essentials: 'Brand Essentials',
    brand_identity: 'Brand Identity',
    brand_color: 'Brand Colour',
    brand_color_desc:
      'Your brand color will be used for visual highlights in your academy',
    logo_title: '<b>Logo: </b>upto 240x120',
    favicon_title: '<b>Favicon: </b>30x30',
    hex: '#000FF0',
    analytics: 'Analytics',
    updated: 'Settings updated successfully',
    image_updated: 'Image updated successfully',
    copy_url: 'Copy Academy URL',
    go_to: 'Go to Academy',
    moderators: 'Moderators',
    moderators_desc: 'Add moderators to your academy',
    languages: {
      title: 'Languages',
      desc: 'Add languages to your academy',
      add: 'Add Language',
      default: 'Default Language',
      popover_title: 'Add Academy Languages'
    }
  },
  reorder: 'Reorder you chapters',
  learner_groups: {
    static: {
      label: 'Choose users ',
      desc: 'You can choose one or multiple customers',
      search: 'Search customers…'
    },
    dynamic: {
      label: 'Filter dynamically through authentication',
      add_condition: '+ Add Condition'
    }
  },
  course_analytics: {
    analytics: 'Analytics',
    learners_enrolled: 'Learners Enrolled',
    learners_completed: 'Learners Completed',
    assessment_taken: 'Assessment Taken',
    certified_learners: 'Certified Learners',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    enrolled_on: 'Enrolled On',
    completed: 'Completed',
    certified: 'Certified',
    assessment_attempts: 'Assessment Attempts',
    yes: 'Yes',
    no: 'No',
    no_results_found: 'No results found!',
    export: {
      button: 'Export',
      title: 'Export Course Analytics',
      desc: `A CSV file containing the course analytics will be sent to your email.`
    }
  },
  analytics_dashboard: {
    title: 'Academy Home',
    description:
      'Delve into your academy data and analytics (Updated every 24 hours)',
    empty_dashboard: 'No analytics found!',
    live_courses: 'Live Courses',
    enrolled_courses: 'Total Course Enrollments',
    completed_courses: 'Total Course Completions',
    total_certifications: 'Total Certificates Issued'
  }
};
